var productTypes = [
    { label: "Treadmill",       value: 0 },
    { label: "Incline_trainer", value: 1 },
    { label: "Ellipticals",     value: 2 },
    { label: "Bikes",           value: 3 },
  ]
//0=Treadmill 1=Incline_trainer 2=Ellipticals 3=Bikes
module.exports = {
    productTypes
}